import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pad10 with_white_bg noscroll",
  style: {"height":"400px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs24 kakugo centered fw600",
    style: {"color":"#696969"}
  }, "リンクを取得")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mb20"
}
const _hoisted_5 = { class: "fs12 w100 fw600" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt10" }, "確定情報", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "warningText fs12 kakugo" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "■ 調整ページログインURL"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("リンク先のURLを表示するとそのユーザーで入室済みになりますので、予めご了承ください。 ")
], -1)
const _hoisted_9 = { class: "fs12 w100 fw600" }
const _hoisted_10 = { class: "fl mt10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "RoomMembersLinkModal",
    "content-class": "ofs modalContent shadowContent rad10 pad15 modalNarrow noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (_ctx.members)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "text",
              style: _normalizeStyle({
                    padding: _ctx.isSP ? `` : `20px`,
                    width: _ctx.isSP ? `` : `410px`,
                    color: `#696969`,
                })
            }, [
              (_ctx.room && _ctx.room.current_appointment?.status == 10)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("label", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_CopyButton, {
                        linkUrl: _ctx.copyFixText,
                        gtagCategory: `確定情報をコピー`,
                        buttonName: `確定情報をコピー`,
                        width: 120,
                        class: "fr"
                      }, null, 8, ["linkUrl"])
                    ]),
                    _createVNode(_component_TextareaTag, {
                      placeholder: "こちらをコピーしてメールなどに貼り付けてください。",
                      style: {"height":"120px"},
                      class: "fs14 roundForm mw100 mt10 fixContent",
                      value: _ctx.copyFixText,
                      onClickTextarea: _ctx.clickFixText,
                      onInputValue: _ctx.inputFixContentValue
                    }, null, 8, ["value", "onClickTextarea", "onInputValue"]),
                    _hoisted_7
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member, memberindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"margin-top":"30px"},
                  key: memberindex
                }, [
                  _createElementVNode("label", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(member.company_name) + "  " + _toDisplayString(member.name) + "様", 1),
                    _createVNode(_component_CopyButton, {
                      linkUrl: member.link,
                      gtagCategory: `メンバーのリンク取得`,
                      class: "fr"
                    }, null, 8, ["linkUrl"])
                  ]),
                  _hoisted_11,
                  _createVNode(_component_TextfieldTag, {
                    style: {"height":"50px","min-width":"280px","max-width":"100%","margin-top":"10px"},
                    class: _normalizeClass(`fl fs14 roundForm w100 member${memberindex}`),
                    value: member.link,
                    onClickTextfield: ($event: any) => (_ctx.clickTextfield(memberindex))
                  }, null, 8, ["class", "value", "onClickTextfield"]),
                  _hoisted_12,
                  _hoisted_13
                ]))
              }), 128))
            ], 4))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}